import { infoHeadTitleList } from "./parts";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { funInfoBodyList } from "./hooks/useHooks";
import {
  httpAPI_PRE002,
  httpAPI_PRE003,
  httpAPI_REC009,
  httpAPI_REC014,
} from "./api/request";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkButton from "../../components/atoms/TkButton";
import { Box, Typography } from "@mui/material";
import TkMemo from "../../components/molecules/TkMemo";
import { IAPI_PRE002_Response } from "../../type/apiType";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { changeAmountFormat } from "../../utils/useTools";
import { TkGetCode } from "../../utils/TkGetCode";
import TkDataTable from "../../components/molecules/TkDataTable";
import {
  ApplicationStatus,
  CollectionStatus,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import dayjs from "dayjs";
import { GlobalContext } from "../../context/globalContext";

/**
 * SCRW080002 掛金届出状況詳細
 * このコンポーネントは、infoHeadTitleListをレンダリングします。
 * @returns SCRW080002 掛金届出状況詳細
 */
const SCRW080002 = () => {
  let location = useLocation();
  const { state: globalState, setState } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [resData, setResData] = useState<IAPI_PRE002_Response>({});
  const [infoBodyList, setInfoBodyList] = useState<any>([]);
  const [memo, setMemo] = useState<string>("");
  const [openReceiveSuccess, setOpenReceiveSuccess] = useState<boolean>(false);
  const [openSurchargeSuccess, setOpenSurchargeSuccess] =
    useState<boolean>(false);
  const [openCommentSuccess, setOpenCommentSuccess] = useState<boolean>(false);
  const contractorNo = location.state?.contractorNo;

  useEffect(() => {
    newIndication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const newIndication = async () => {
    // 掛金届出状況詳細表示API実行
    try {
      const res = await httpAPI_PRE002({ contractorNo });

      if (res.resultCd === "I0000") {
        const infoBody = funInfoBodyList(res.pastPremiumList);
        setInfoBodyList(infoBody);

        setResData(res);

        setState({
          ...globalState,
          errorMsgId: "",
        });
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const updateReceive = async () => {
    // 入金状況更新API 呼び出し
    try {
      const res = await httpAPI_REC009({
        invoiceId: resData?.invoiceId,
        status: "2",
      });

      if (res.resultCd === "I0000") {
        setState({
          ...globalState,
          errorMsgId: "",
        });
        newIndication();
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const updateSurcharge = async () => {
    try {
      // 割増金請求状態更新API 呼び出し
      const res = await httpAPI_REC014({
        billingStatusDataList: [{ invoiceId: resData?.surchargeInvoiceId }],
      });

      if (res.resultCd === "I0000") {
        setState({
          ...globalState,
          errorMsgId: "",
        });
        newIndication();
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const saveMemo = (data: any) => {
    setMemo(data.target.value);
  };

  const updateMemo = async () => {
    try {
      const res = await httpAPI_PRE003({ contractorNo, memo });
      if (res.resultCd === "I0000") {
        setState({
          ...globalState,
          errorMsgId: "",
        });
        newIndication();
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const okReceiveDialog = () => {
    setOpenReceiveSuccess(false);
    updateReceive();
  };

  const okSurchargeDialog = () => {
    setOpenSurchargeSuccess(false);
    updateSurcharge();
  };

  const okCommentDialog = () => {
    setOpenCommentSuccess(false);
    updateMemo();
  };

  const openReceiveDialog = () => {
    setOpenReceiveSuccess(true);
  };

  const openSurchargeDialog = () => {
    setOpenSurchargeSuccess(true);
  };

  const openCommentDialog = () => {
    if (memo === "") return;
    setOpenCommentSuccess(true);
  };

  return (
    <Box data-testid="SCRW080002PageForTest" className="tkSCRW080002">
      <Box>
        <Typography>{(resData.year?.toString() ?? "") + "年度"}</Typography>
        <TkContractorAndNumberLine
          name="契約者(法人)名"
          no={
            (resData.contractorNo ?? "") + ":" + (resData.contractorName ?? "")
          }
        />
        <Box className="tkTextLine">
          <Typography className="tkRightSpace">
            掛金届：
            {resData.lastApplyStatus &&
              ApplicationStatus[
                resData.lastApplyStatus as keyof typeof ApplicationStatus
              ]}
          </Typography>
        </Box>
        <Box className="tkTextLine">
          <Typography className="tkRightSpace">
            延長申請：
            {resData.extensionApplyFlg === YesOrNoFlug["有"] ? (
              <Typography component={"span"} className="tkRightSpace">
                {"あり（" +
                  dayjs(resData.extensionApplyDeadline).format("MM/DD") +
                  "まで）"}
              </Typography>
            ) : (
              "なし"
            )}
          </Typography>
        </Box>
        <Box className="tkTextLine">
          <Typography component={"span"} className="tkRightSpace">
            掛金：
            <Typography
              component={"span"}
              className={
                resData.receiveStatus === "3"
                  ? "tkWordColor tkRightSpace"
                  : "tkRightSpace"
              }
            >
              {TkGetCode(CollectionStatus, resData.receiveStatus)}
            </Typography>
          </Typography>
          {resData.lastApplyStatus === "13" &&
            (resData.receiveStatus === "3" ||
              resData.receiveStatus === "4") && (
              <TkButton onClick={openReceiveDialog}>
                {"入金完了として扱う"}
              </TkButton>
            )}
        </Box>
        <Box className="tkDetailText">
          <Box className="tkWordSpace">
            <Typography className="tkSmallText">
              請求：{changeAmountFormat(resData.receiveInvoiceAmt ?? 0)}
            </Typography>
          </Box>
          <Box className="tkWordSpace">
            <Typography className="tkSmallText">
              納付：{changeAmountFormat(resData.receiveDepositAmt ?? 0)}
            </Typography>
          </Box>
        </Box>
        <Box className="tkTextLine">
          <Typography className="tkRightSpace">
            割増金：
            <Typography
              component={"span"}
              className={
                resData.surchargeReceiveStatus === "3"
                  ? "tkWordColor tkRightSpace"
                  : "tkRightSpace"
              }
            >
              {resData.surchargeReceiveInvoiceAmt === 0 ||
              resData.surchargeReceiveInvoiceAmt === null ? (
                "なし"
              ) : resData.surchargeReceiveStatus !== "3" ? (
                "発生（" +
                (TkGetCode(CollectionStatus, resData.surchargeReceiveStatus) ??
                  "") +
                "）"
              ) : (
                <>
                  発生
                  <Typography
                    component={"span"}
                    className={"tkWordColor tkRightSpace"}
                  >
                    （
                    {TkGetCode(
                      CollectionStatus,
                      resData.surchargeReceiveStatus
                    )}
                    ）
                  </Typography>
                </>
              )}
            </Typography>
          </Typography>

          {resData.lastApplyStatus === "13" &&
            resData.surchargeReceiveStatus === "0" && (
              <TkButton onClick={openSurchargeDialog}>
                {"請求対象外とする"}
              </TkButton>
            )}
        </Box>
        {resData.surchargeReceiveInvoiceAmt &&
          resData.surchargeReceiveInvoiceAmt > 0 && (
            <Box className="tkDetailText">
              <Typography className="tkSmallText">
                発生額：
                <Typography component={"span"} className="tkSmallText">
                  {changeAmountFormat(resData.surchargeReceiveInvoiceAmt)}
                </Typography>
              </Typography>
            </Box>
          )}
        <Box className="tkTopSpace">
          <Typography>{"過年度の掛金"}</Typography>
        </Box>
      </Box>
      <TkDataTable
        headList={infoHeadTitleList}
        bodyList={infoBodyList}
        count={infoBodyList.length}
        defaultRowsPerPage={10}
        pagin
        showUnit
      />
      <Box className="tkTopSpace">
        <TkMemo
          onChange={saveMemo}
          showCheckBox={false}
          wantToSetValue={resData?.memo}
        />
      </Box>
      <Box className="tkDisplay">
        <TkBackButton />
        <TkButton onClick={openCommentDialog}>{"メモを登録"}</TkButton>
      </Box>
      <TkMessageDialog
        open={openReceiveSuccess}
        title="確認（請求者情報を登録します）"
        contextText="　入金完了に更新します。よろしいですか？"
        okText="はい"
        cancelText="いいえ"
        onOky={okReceiveDialog}
        onCancel={() => setOpenReceiveSuccess(false)}
      />
      <TkMessageDialog
        open={openSurchargeSuccess}
        title="確認（更新を行います）"
        contextText="　請求対象外として扱いますが、問題ないでしょうか。"
        okText="はい"
        cancelText="いいえ"
        onOky={okSurchargeDialog}
        onCancel={() => setOpenSurchargeSuccess(false)}
      />
      <TkMessageDialog
        open={openCommentSuccess}
        title="確認（情報を登録します）"
        contextText="　メモ欄の内容を登録します。"
        okText="はい"
        cancelText="いいえ"
        onOky={okCommentDialog}
        onCancel={() => setOpenCommentSuccess(false)}
      />
    </Box>
  );
};

export default SCRW080002;
